import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pop-over-content',
  templateUrl: './pop-over-content.component.html',
  styleUrls: ['./pop-over-content.component.less']
})
export class PopOverContentComponent implements OnInit {
  @Input() sets;
  @Output() popClick: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }
  onClick() {
    this.popClick.emit();
  }

}
